import React from 'react';
import PropTypes from 'prop-types';

const IconDragEqual = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = 'none' }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill={color}>
        <rect x='2' y='5' width='12' height='2' fill='#1F1F1F' />
        <rect x='2' y='9' width='12' height='2' fill='#1F1F1F' />
    </svg>;

};

IconDragEqual.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};

export default IconDragEqual;
